import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { SessionConfiguration } from '#src/shared/session';

/** @knip-ignore */
export const {
	Context: SessionConfigurationContext,
	Provider: SessionConfigurationContextProvider,
	useContext: useSessionConfigurationContext,
} = createMandatoryContext<SessionConfiguration>(undefined, {
	name: 'SessionConfigurationContext',
});
